import {
  Box, Theme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PayoutDialogContentType } from '../../../common/enums';
import { GoBackLink, TransparentPayoutCTA } from './Common';

type RemovePaymentMethodConfirmProps = {
  onConfirmDeleteBtnClick?: () => void;
  setDialogContentType?: (event: PayoutDialogContentType) => void;
  setDialogSubTitle?: (event: string | JSX.Element) => void;
};

export function RemovePaymentMethodConfirm({
  onConfirmDeleteBtnClick,
  setDialogContentType,
  setDialogSubTitle,
}: RemovePaymentMethodConfirmProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={(theme: Theme) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
      })}
    >
      <TransparentPayoutCTA
        text={`${t('button.deleteAccount')}`}
        onClick={onConfirmDeleteBtnClick}
      />
      <Box
        sx={{
          alignSelf: 'center',
        }}
      >
        <GoBackLink
          setDialogContentType={setDialogContentType}
          setDialogSubTitle={setDialogSubTitle}
        />
      </Box>
    </Box>
  );
}
